import { useTranslation } from 'react-i18next';

import { BotSandbox } from '@/components/onboarding/sandbox/BotSandbox';
import { PageHeader } from '@/components/shared/PageHeader';
import { Skeleton } from '@/components/ui/skeleton';
import { useOnboardingState } from '@/contexts/OnboardingContext';

/**
 * F054 — "Testar o bot" persistent nav page.
 *
 * Mounts the self-contained BotSandbox so the owner can dry-run the bot at any
 * lifecycle stage without touching real Instagram DMs.  No status gating —
 * available from first setup onward.
 *
 * businessName comes from OnboardingContext.profile; BotSandbox handles the
 * empty-name case with '?' initials.
 */
export function TestBotPage() {
  const { t } = useTranslation();
  const { profile, loading } = useOnboardingState();

  if (loading) {
    return (
      <div className="space-y-6" data-testid="test-bot-page-loading">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 h-full" data-testid="test-bot-page-full-height">
      <PageHeader title={t('test.page.title')} subtitle={t('test.page.subtitle')} />
      {/*
       * F055 — full-height chat: the messages region inside BotSandbox fills
       * the remaining column height; the composer is anchored at the bottom.
       * `flex-1 min-h-0` lets the sandbox grow into available space without
       * overflowing the page scroll container (CSS flex height gotcha).
       * The embedded wizard PreviewSection keeps its own compact layout
       * (no changes to BotSandbox's internal min/max-h constraints — the
       * wrapper here overrides with flex-1 for the /test page context only).
       */}
      <div className="flex-1 min-h-0 flex flex-col">
        <BotSandbox businessName={profile?.business_name ?? ''} />
      </div>
    </div>
  );
}
